const authority = import.meta.env.VITE_KEYCLOAK_AUTHORITY || 'http://localhost:8080/realms/sbt';
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'bigfoot-ui';

export const oidcConfig = {
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/authentication/callback`,
  silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`, // For iframe-based silent renewal fallback
  scope: 'openid profile email offline_access',
  service_worker_relative_url: '/OidcServiceWorker.js',
  service_worker_only: false,
  token_renew_mode: 'access_token_or_id_token_invalid', // Renew only when token is invalid
  monitor_session: false, // Disable session monitoring to avoid extra requests
};

export default oidcConfig;
